import { Box } from '@mui/material';

function SlashScreen() {
  return (
    <Box
      sx={{
        alignItems: 'center',
        backgroundColor: 'background.paper',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        justifyContent: 'center',
        left: 0,
        p: 3,
        position: 'fixed',
        top: 0,
        width: '100%',
        zIndex: 2000
      }}
    >
      <img
        src="/static/logo.png"
        alt="redpoint logo"
        width="100"
      />
    </Box>
  );
}

export default SlashScreen;
